export default () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5 0.5H1.5C1.22386 0.5 1 0.723858 1 1V16C1 16.2761 1.22386 16.5 1.5 16.5H14.5C14.7761 16.5 15 16.2761 15 16V5C15 4.86211 14.9442 4.73725 14.8539 4.6468C14.8538 4.64668 14.8537 4.64656 14.8536 4.64645L10.8536 0.646447C10.7598 0.552678 10.6326 0.5 10.5 0.5ZM10 1.5H2V15.5H14V5.5H10.5C10.2239 5.5 10 5.27614 10 5V1.5ZM13.2929 4.5L11 2.20711V4.5H13.2929Z"
    />
  </svg>
)
